import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export const addBatchApi = async (
    url: string,
    name: string,
    course: string,
    courseType: string,
    startTime: string,
    endTime: string,
    fees: number,
    status: string
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.post(
            `${url}/Batch/Create`,
            {
                name,
                course,
                courseType,
                startTime,
                endTime,
                fees,
                status
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getBatchApi = async (
    url: string,
    CourseType: string | null = null,
    Course: string | null = null,
    TimeRange: string | null = null,
    searchTerm: string | null = null,
    currentPage: number = 1,
    itemsPerPage: number = 10
) => {
    const token = cookies.get('authToken');
    const params = new URLSearchParams();

    if (CourseType) params.append('CourseType', CourseType);
    if (Course) params.append('Course', Course);
    if (TimeRange) params.append('TimeRange', TimeRange);
    if (searchTerm) params.append('searchTerm', searchTerm);
    params.append('pageNumber', currentPage.toString());
    params.append('pageSize', itemsPerPage.toString());

    try {
        const response = await axios.get(
            `${url}/Batch/GetAll?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateBatchApi = async (
    url: string,
    batchData: {
        Id: string; // Batch ID
        Name: string;
        CourseType: string;
        Course: string;
        StartTime: string;
        EndTime: string;
        Status: string
    }
) => {
    const token = cookies.get("authToken"); // Retrieve the authentication token

    try {
        const response = await axios.put(
            `${url}/Batch/Update`, // Endpoint URL
            batchData, // Request body
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json", // Specify JSON content type
                },
            }
        );
        return response.data; // Return the response from the API
    } catch (error) {
        console.error("Failed to update batch:", error);
        throw error;
    }
};

export const getBatchByIdApi = async (url: string, id: string) => {
    const token = cookies.get("authToken"); // Retrieve the authentication token

    try {
        const response = await axios.get(
            `${url}/Batch/GetById/${id}`, // Endpoint URL
            {
                headers: {
                    Authorization: `Bearer ${token}`, // Include the token in the headers
                },
            }
        );
        return response.data; // Return the batch data
    } catch (error) {
        console.error("Failed to fetch batch by ID:", error);
        throw error; // Throw the error for further handling
    }
};